import React from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { useAppSelector } from 'store/hooks'
import { type Role } from 'common/utils/types'
import { getMainAppForRole } from 'common/utils/functions'

export const RequireAuth: React.FC<{ acceptedRoles: Role[] }> = ({ acceptedRoles }): React.ReactElement => {
  const { userInfo, isAuthenticated } = useAppSelector((state) => state.auth)

  if (!isAuthenticated) {
    return <Navigate to={{ pathname: '/auth' }} replace />
  }

  if (userInfo?.role && !acceptedRoles.includes(userInfo?.role)) {
    window.location.replace(window.location.origin + getMainAppForRole(userInfo?.role))
  }

  return <Outlet />
}

export const RedirectIfAuth = (): React.ReactElement => {
  const { isAuthenticated } = useAppSelector((state) => state.auth)

  if (isAuthenticated) {
    return <Navigate to={{ pathname: '/' }} replace />
  }

  return <Outlet />
}
